import React, { Component } from 'react';
import classNames from 'classnames';

if (process.env.NODE_ENV !== 'test') {
  require('./Component.scss');
}

export default class ComponentWrapper extends Component {
  render() {
    return (
      <div className={classNames('ComponentWrapper', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}
